import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';

import { getIsLoading, isMobileMapOpen } from '../selectors';
import SearchResultsLoader from '../components/SearchResultsLoader';

export default connect((state: GlobalState) => ({
  loading: getIsLoading(state),
  isMobileMapOpen: isMobileMapOpen(state),
}))(SearchResultsLoader);
